export default __webpack_public_path__ + "static/media/avatar.e2cd5f45.jpg";